<template>
  <common-modal
    :name="name"
    :primaryAction="primaryAction"
    :secondaryActions="secondaryActions"
    :title="title"
    :onClosed="false"
    height="auto"
    width="80%"
  >
    <template #modal-body>
      <validation-form @on-submit="addTerm" ref="addForm">
        <md-card class="my-0">
          <md-card-content>
            <TermInfoForm
              ref="termInformation"
              :serverValidations="serverValidations"
            />
          </md-card-content>
        </md-card>
      </validation-form>
    </template>
  </common-modal>
</template>

<script>
import { service_paths } from "@/constants/Services";
import CommonModal from "@/components/Base/CommonModal";
import { genErrMsgOj, Message } from "@/helpers/utils";
import TermInfoForm from "./TermInfoForm";

export default {
  components: { TermInfoForm, CommonModal },
  props: ["name", "title"],
  data() {
    return {
      serverValidations: {},
      primaryAction: {
        title: "common.add_new",
        action: this.doSubmit
      },
      secondaryActions: [
        {
          title: "common.cancel",
          action: this.closeModal
        }
      ]
    };
  },
  inject: ["reFetchTableData"],
  methods: {
    closeModal() {
      this.$modal.hide(this.name);
    },
    async addTerm() {
      const form = this.$refs.termInformation.formData;
      this.$axios
        .post(
          service_paths.terms,
          form,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(async () => {
          this.closeModal();
          await this.reFetchTableData();
          Message.success(this.$t("common.add_success"));
        })
        .catch(error => {
          const errData = error.response?.data;

          if (errData) this.serverValidations = genErrMsgOj(errData.messages);
        });
    },
    doSubmit() {
      this.$refs.addForm.submitForm();
    }
  }
};
</script>
